module.exports = __webpack_public_path__ + "img/news02.f7fa3570.jpeg";